module.exports = __webpack_public_path__ + "static/learn_remember_apply_breath-44849374510bb02c3942bb5760382aea.png";